import { getSortedTrustees } from 'app/pages/companies/companies/company/tabs/formFieldData/components/Trustees/Trustees.utils';
import memoizeOne from 'memoize-one';
import { createSelector } from 'reselect';

import { getCompany } from './company.selectors';

const selectCompanyFormFieldData = createSelector(getCompany, ({ formFieldData }) => formFieldData);

export const selectCompanyFormFieldDataByCompanyId = memoizeOne(companyId =>
  createSelector(selectCompanyFormFieldData, formFieldData => formFieldData[companyId]),
);

export const selectCompanyTrusteesByCompanyId = memoizeOne(companyId =>
  createSelector(selectCompanyFormFieldDataByCompanyId(companyId), formFieldData =>
    getSortedTrustees(formFieldData?.trustees || []),
  ),
);
